import { withInstall } from 'framework/utils'
import appSiteSelect from './src/AppSiteSelect.vue'
import appCurrencySelect from './src/AppCurrencySelect.vue'
import appSiteTabs from './src/AppSiteTabs.vue'
import dataSelect from './src/DataSelect.vue'
import appMenuSelect from './src/AppMenuSelect.vue'
import appMaxTagSelect from './src/AppMaxTagSelect.vue'
import { useComponentRegister } from 'framework/components/Form/index'
import appCategory from '../Category/Category.vue'

// 将admin的component注入到 framenwork的Form组件中
;[
  ['AppCategory', appCategory],
  ['AppSiteSelect', appSiteSelect],
  ['DataSelect', dataSelect],
  ['AppCurrencySelect', appCurrencySelect],
  ['AppMenuSelect', appMenuSelect],
  ['AppMaxTagSelect', appMaxTagSelect],
].forEach(([name, comp]) => {
  useComponentRegister(name as any, comp)
})

export const AppCategory = withInstall(appCategory)
export const AppSiteSelect = withInstall(appSiteSelect)
export const AppMenuSelect = withInstall(appMenuSelect)
export const AppCurrencySelect = withInstall(appCurrencySelect)
export const AppSiteTabs = withInstall(appSiteTabs)
export const DataSelect = withInstall(dataSelect)
export const AppMaxTagSelect = withInstall(appMaxTagSelect)
